import { render } from "./InfoRow.vue?vue&type=template&id=6d66823a"
import script from "./InfoRow.vue?vue&type=script&lang=js"
export * from "./InfoRow.vue?vue&type=script&lang=js"

import "./InfoRow.vue?vue&type=style&index=0&id=6d66823a&lang=scss"
import "./InfoRow.vue?vue&type=style&index=1&id=6d66823a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__